import PropTypes from "prop-types";

// @mui material components
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { SPACE } from "assets/theme/avocadoBrand";

/**
 * Nhãn nhỏ đặt trên tiêu đề (eyebrow): gạch ngắn + chữ hoa giãn rộng, tạo
 * nhịp đọc kiểu chứng từ. Xuất riêng vì còn dùng lại ở tiêu đề Dialog, nơi
 * không có cả khối đầu trang.
 */
export function NhanDau({ children }) {
  return (
    <MDBox display="flex" alignItems="center" gap={1} mb={0.5}>
      <MDBox
        sx={({ palette }) => ({
          width: SPACE[5],
          height: SPACE[1] / 2,
          borderRadius: 1,
          backgroundColor: palette.info.main,
        })}
      />
      <MDTypography variant="overline" color="info" lineHeight={1}>
        {children}
      </MDTypography>
    </MDBox>
  );
}

NhanDau.propTypes = {
  children: PropTypes.node.isRequired,
};

/**
 * Khối đầu trang: eyebrow (nhóm) + mô tả ngắn + nút hành động.
 * Tên trang (vd. "Hợp tác xã") hiện trên DashboardNavbar — không lặp h4 ở đây.
 * `tieuDe` vẫn nhận từ call site để tương thích, nhưng không render.
 */
function DauTrang({ nhan, moTa, children }) {
  return (
    <MDBox mb={3}>
      <MDBox
        display="flex"
        flexWrap="wrap"
        alignItems="flex-end"
        justifyContent="space-between"
        gap={2}
      >
        <MDBox minWidth={0} flex={1}>
          <NhanDau>{nhan}</NhanDau>
          {moTa && (
            <MDTypography variant="button" fontWeight="regular" color="text">
              {moTa}
            </MDTypography>
          )}
        </MDBox>
        {children && (
          <MDBox
            sx={{
              width: { xs: "100%", sm: "auto" },
              "& > *": { width: { xs: "100%", sm: "auto" } },
            }}
          >
            {children}
          </MDBox>
        )}
      </MDBox>
      <Divider sx={{ mt: 2, mb: 0 }} />
    </MDBox>
  );
}

DauTrang.propTypes = {
  nhan: PropTypes.node.isRequired,
  /** Không còn hiện — tên trang nằm trên navbar. Giữ prop để không sửa hàng loạt layout. */
  tieuDe: PropTypes.node,
  moTa: PropTypes.node,
  children: PropTypes.node,
};

export default DauTrang;
